<template>
    <div>
      <div class="container-fluid">
        <div class="row mt-2">
          <div class="col-lg-9 col-md-9 col-sm-9 col-9 mt-1">
            <input class="search" v-model="name" @keyup="btnSearch()" type="search" placeholder="Cari Indikator ...">
          </div>
          <div class="col-lg-3 col-md-3 col-sm-3 col-3">
              <componentProfile></componentProfile>
          </div>
        </div>
        <div class="row">
          <h1 class="col-lg-3 col-md-3 col-sm-3 text-white fw-bold mt-3">Indikator</h1>
          <div class="col-lg-5 col-md-4 col-sm-5"></div>
          <div class="col-lg-3 col-md-4 col-sm-3 mt-3 text-end mx-3">
            <button v-b-modal.modal-addIndicator class="btn btn-add">
              <b-icon class="icon-plus" icon="plus-circle-fill"></b-icon>Tambah Indikator
            </button>
          </div>
        </div>
        <div class="row">
            <div class="col-lg-11 white mt-2">
                <div class="row">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-7 col-md-7 mt-5">
                        <h4 class="fw-bolder grey-font">Semua Indikator</h4>
                        <h5 class="grey-font mt-4">Silahkan memilih indikator</h5>
                    </div>
                    <div class="col-lg-4 col-md-4 d-none d-xl-block">
                        <img class="img-subjek img-responsive" src="../assets/img/girl.svg" alt="Eureka">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="container-fluid mt-5 pt-3 text-start">
                <div class="row top-table bg-white" style="width: 100%;">
                    <div class="col-lg-4 col-md-2 col-sm-2 col-3">Indikator</div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-3">Subjek</div>
                    <div class="col-lg-2 col-md-3 col-sm-3 col-3">Dibuat Oleh</div>
                    <div class="col-lg-2 col-md-4 col-sm-4 col-4">Diperbaharui Oleh</div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-2">Aksi</div>
                </div>
            </div>
            <div class="container-fluid text-start mt-3 mb-5">
                <div class="row bg-white bottom" style="width: 100%;">
                    <div v-if="isErrorIndicator">{{errMessageIndicator}}</div>
                    <div v-else>
                        <div v-for="(item, i) in getIndicator" :key="i">
                            <div class="row my-2">
                                <div class="col-lg-4 col-md-2 col-sm-3 col-3">{{item.name}}</div>
                                <div class="col-lg-2 col-md-2 col-sm-3 col-3">{{item.subject_name}}</div>
                                <div class="col-lg-2 col-md-3 col-sm-2 col-3">{{item.name_creator}}</div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-3" v-if="!item.name_updater">
                                    -
                                </div>
                                <div v-else class="col-lg-2 col-md-2 col-sm-2 col-2">
                                    {{item.name_updater}}
                                </div>
                                <div class="col-lg-2 col-md-5 col-sm-5">
                                  <button @click="btnEdit(item.id)" v-b-modal.modal-editIndicator class="px-3 btn btn-edit">Edit</button>
                                  <button @click="btnDelete(item.id)" v-if="getDetailAcc.id_level === 1" class="px-2 btn mx-3 btn-delete">Hapus</button>
                                  <div v-if="getDetailAcc.id_level === 2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-if="!isErrorIndicator">
              <b-pagination
                align="right"
                class="mt-3 mx-2 pagination"
                @input="indicator()"
                v-model="getPaginationIndicator.page"
                pills
                :total-rows="getPaginationIndicator.totalData"
                :per-page="getPaginationIndicator.limit"
                size="sm"
              >
              </b-pagination>
            </div>
            <div v-else>
                <b-pagination
                    align="right"
                    class="mt-3 pagination"
                    pills
                    total-rows="1"
                    per-page="1"
                    size="sm"
                >
                </b-pagination>
            </div> -->
        </div>
      </div>
      <!-- Modal Insert Indicator -->
      <b-modal
      id="modal-addIndicator"
      ref="modal-addIndicator"
      hide-header-close hide-footer hide-header centered>
      <div class="mx-4">
        <h3 class="text-center my-2 mb-4 fw-bolder">Tambah Indikator</h3>
        <h5 class="fw-bold">Subjek</h5>
        <select
          v-model="form.subject_id"
          class="form-select form-select-sm mb-3 insertSelect" required
        >
          <option value="" disabled>Pilih Subjek</option>
          <option v-for="(el, i) in getAllSubject" :key="i" :value="el.id_subject">
            {{el.subject_name}}
          </option>
        </select>
        <h5 class="fw-bold mt-3">Indikator</h5>
        <input class="inputText" v-model="form.name" type="text" placeholder="Tambahkan Indikator">
        <button class="btn cancelBtn" @click="hideModal()">Cancel</button>
        <button class="btn editBtn" @click="btnInsert()">Save</button>
      </div>
      </b-modal>
      <!-- Modal Edit Indicator -->
      <b-modal id="modal-editIndicator"
      ref="modal-editIndicator"
      hide-header-close hide-footer hide-header centered>
      <div class="mx-4">
        <h3 class="text-center my-2 mb-4 fw-bolder">Edit Indikator</h3>
        <h5 class="fw-bold">Subjek</h5>
        <select
          v-model="getDetail.subject_id"
          class="form-select form-select-sm mb-3 insertSelect" required
        >
          <option value="" disabled>Pilih Subjek</option>
          <option v-for="(el, i) in getAllSubject" :key="i" :value="el.id_subject">
            {{el.subject_name}}
          </option>
        </select>
        <h5 class="fw-bold">Indikator</h5>
        <input class="inputText" v-model="getDetail.name" type="text">
        <button class="btn cancelBtn" @click="hideModal()">Cancel</button>
        <button class="btn editBtn" @click="btnSave()">Save</button>
      </div>
      </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import componentProfile from './Profile.vue'
import Swal from 'sweetalert2'
import alert from '../helper/alert'
export default {
  data () {
    return {
      name: '',
      form: {
        name: '',
        subject_id: ''
      }
    }
  },
  mixins: [alert],
  components: {
    componentProfile
  },
  computed: {
    ...mapGetters({
      getIndicator: 'indicator/getIndicator',
      getPaginationIndicator: 'indicator/getPaginationIndicator',
      isErrorIndicator: 'indicator/isErrorIndicator',
      errMessageIndicator: 'indicator/errMessageIndicator',
      getDetailAcc: 'account/getDetailAcc',
      getId: 'auth/getId',
      getDetail: 'indicator/getDetail',
      getAllSubject: 'subject/getAllSubject'
    })
  },
  methods: {
    ...mapActions({
      actionIndicator: 'indicator/actionIndicator',
      actionDetailAcc: 'account/actionDetail',
      actionInsert: 'indicator/actionInsert',
      actionDelete: 'indicator/actionDelete',
      actionDetail: 'indicator/actionDetail',
      actionEdit: 'indicator/actionEdit',
      allSubject: 'subject/allSubject'
    }),
    subject () {
      this.allSubject()
    },
    indicator () {
      const data = {
        page: this.getPaginationIndicator.page ? this.getPaginationIndicator.page : 1,
        name: this.name ? this.name : '',
        limit: ''
      }
      this.actionIndicator(data)
    },
    btnSearch () {
      const data = {
        page: this.getPaginationIndicator.page ? this.getPaginationIndicator.page : 1,
        name: this.name ? this.name : '',
        limit: ''
      }
      this.actionIndicator(data)
    },
    detailAcc () {
      this.actionDetailAcc(this.getId)
    },
    btnInsert () {
      const data = {
        name: this.form.name,
        subject_id: this.form.subject_id,
        id_creator: this.getId
      }
      this.actionInsert(data).then((response) => {
        this.hideModal()
        this.indicator()
        this.ToastSuccess('Data berhasil ditambahkan.')
      }).catch(() => {})
    },
    btnDelete (id) {
      Swal.fire({
        title: 'Apakah anda yakin ingin menghapus data ini?',
        imageWidth: 100,
        imageHeight: 100,
        imageUrl: this.image,
        showCancelButton: true,
        confirmButtonColor: '#D51A1A',
        cancelButtonColor: '#4DAB14',
        confirmButtonText: 'Hapus',
        cancelButtonText: 'Batalkan'
      }).then((result) => {
        if (result.isConfirmed) {
          this.ToastSuccess('Data anda telah dihapus.')
          this.actionDelete(id).then((response) => {
            this.indicator()
          }).catch(() => {})
        }
      })
    },
    btnEdit (id) {
      this.actionDetail(id)
    },
    btnSave () {
      const data = {
        id: this.getDetail.id,
        name: this.getDetail.name,
        subject_id: this.getDetail.subject_id,
        id_updater: this.getId
      }
      this.actionEdit(data).then((response) => {
        this.ToastSuccess('Data berhasil diperbaharui.')
        this.hideModal()
        this.indicator()
      }).catch(() => {})
    },
    hideModal () {
      this.$refs['modal-editIndicator'].hide()
      this.$refs['modal-addIndicator'].hide()
      this.form = {
        name: '',
        subject_id: ''
      }
    }
  },
  mounted () {
    this.indicator()
    this.subject()
  }
}
</script>

<style scoped>
.bottom{
    border-radius: 10px;
}
select{
  background: url('../assets/img/polygon.png') no-repeat right white;
  background-size: 10px 8px;
  -webkit-appearance: none;
  background-position-x: 90%;
  border: 2px solid rgba(0, 0, 0, 0.65);
  border-radius: 7px;
  padding: 5px 5px 5px 10px;
  width: 90%;
  margin: 5px 0px;
  height: 39px;
}
</style>
